import { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'next/router'

import { withTranslation, Link } from '../../i18n'

import blogCategories from '../../constants/blogCategories'

import {
  BlogHeaderContainer, BlogMenu, BlogMenuItem
} from './styles'

const menuPages = [
  {
    href: '/mag',
    niceHref: '/mag',
    title: 'BLOG_MENU_MAIN'
  },
  ...blogCategories.map(x => ({
    href: `/mag?category=${x.label}`,
    niceHref: `/mag/${x.label}`,
    title: x.title
  })),
  // { href: '/authors', niceHref: '/mag/authors', title: 'BLOG_MENU_AUTHORS' }
]

class BlogHeader extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    router: PropTypes.instanceOf(Object).isRequired
  }

  render() {
    const { t, router: { asPath } } = this.props
    const asPathBase = asPath.replace(/^(\/en\/)/, '/')

    return (
      <BlogHeaderContainer>
        <img alt="Ural Music Magazine" src="/static/images/umm.png" />
        <BlogMenu>
          {menuPages.map(page => (
            <Link key={page.href} href={page.href} as={page.niceHref} passHref>
              <BlogMenuItem selected={page.niceHref === asPathBase}>
                {t(page.title)}
              </BlogMenuItem>
            </Link>
          ))}
        </BlogMenu>
      </BlogHeaderContainer>
    )
  }
}

const WithRouter = withRouter(BlogHeader)
export default withTranslation(['magazine', 'common'])(WithRouter)
